import "core-js/modules/es.string.small.js";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import React from "react";
import { ButtonSizeEnum, ButtonVariantEnum, Icon, IconButton, IconConstants, makeStyles, RaiseButton, Typography, useTheme } from "componentLibrary";
import useWindowSize from "hooks/useWindowSize";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    container: function container(props) {
      var _props$gap;
      return {
        display: "flex",
        width: "100%",
        alignItems: "center",
        gap: (_props$gap = props.gap) !== null && _props$gap !== void 0 ? _props$gap : "24px"
      };
    },
    titleContainer: {
      flexGrow: 1
    },
    closeIcon: {
      cursor: "pointer"
    }
  };
});
var DrawerHeader = function DrawerHeader(_ref) {
  var _useWindowSize$innerW;
  var title = _ref.title,
    onClose = _ref.onClose,
    clearAllClickHandler = _ref.clearAllClickHandler,
    gap = _ref.gap;
  var classes = useStyles({
    gap: gap
  });
  var theme = useTheme();
  var windowSize = (_useWindowSize$innerW = useWindowSize().innerWidth) !== null && _useWindowSize$innerW !== void 0 ? _useWindowSize$innerW : 0;
  var sizes = {
    isSmMdOrUnder: windowSize <= _valuesInstanceProperty(theme.breakpoints).smMd
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classes.container,
    children: [/*#__PURE__*/_jsx("div", {
      className: classes.titleContainer,
      children: typeof title === "string" ? /*#__PURE__*/_jsx(Typography, {
        variant: sizes.isSmMdOrUnder ? "h4" : "h3",
        weight: "semibold",
        children: title
      }) : title
    }), clearAllClickHandler ? /*#__PURE__*/_jsx(RaiseButton, {
      onClick: clearAllClickHandler,
      size: ButtonSizeEnum.small,
      variant: ButtonVariantEnum.textLink,
      children: "Clear All"
    }) : null, /*#__PURE__*/_jsx(IconButton, {
      onClick: onClose,
      width: "40px",
      height: sizes.isSmMdOrUnder ? "30px" : "40px",
      children: /*#__PURE__*/_jsx(Icon, {
        fontSize: "medium",
        className: IconConstants.X
      })
    })]
  });
};
export default DrawerHeader;